import { apiGetUploadLocations } from '~/api/adminApi'
import { showErrors } from '~/utils/helpers'
import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useUsersQuery = () =>
  useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      const { data } = await adminApi.getUsers()
      return data.data
    },
    initialData: []
  })

export const useCourseQuery = (id) =>
  useQuery({
    queryKey: ['course', id],
    queryFn: async () => {
      const { data } = await adminApi.getCourse(id)
      return data.data
    },
    enabled: !!id,
    refetchOnWindowFocus: false
  })

export const useUploadLocationsQuery = () =>
  useQuery({
    queryKey: ['upload-locations'],
    queryFn: apiGetUploadLocations,
    onError: showErrors,
    refetchOnWindowFocus: false
  })
